<template>
    <div>
        <div class="resumeinfo-main" style="position:relative;" v-if="resumeInfo">
            <div class="resume-download">
                <img class="addimg" @click="downloadResume" v-if="resumeInfo.workerInfo.phone.includes('****')" src="../../assets/images/add.png">
                <img v-else src="../../assets/images/addhad.png">
            </div>
            <div class="resumeinfo" style="padding-bottom:50px;">
                <div class="reinfo-t">
                    <div class="reinfo-face">
                        <img v-if="resumeInfo.workerInfo.headImage" :src="resumeInfo.workerInfo.headImage">
                        <img src="//oss.51ztx.com/resu.png" v-else>
                    </div>
                    <h2 class="names">{{resumeInfo.workerInfo.name}}</h2>
                    <ul class="reinfo-spec">
                        <li>{{resumeInfo.workerInfo.sex | sex}}</li>
                        <li v-if="resumeInfo.workerInfo.age">{{resumeInfo.workerInfo.age}}岁</li>
                        <li v-if="resumeInfo.workerInfo.education">{{resumeInfo.workerInfo.education}}</li>
                        <li v-if="resumeInfo.workerInfo.homeProvincenamels">
                            {{resumeInfo.workerInfo.homeProvincename}}{{resumeInfo.workerInfo.homeCityname}}
                        </li>
                    </ul>
                    <!-- <div :class="{reblur:resumeInfo.workerInfo.phone.includes('****')}"> -->
                        <div>
                        <div class="rephone">
                            <i class="iconfont icon-call_ico"></i>
                            <span>{{resumeInfo.workerInfo.phone}}</span>
                        </div>
                        <div class="readdress">
                            <i class="iconfont icon-loction_ico"></i>
                            <span
                                    v-if="resumeInfo.workerInfo.address">{{resumeInfo.workerInfo.address}}</span>
                            <span v-else style="color: #ccc;">暂无地址详情信息</span>
                        </div>
                    </div>
                    <div class="redown" style="padding-bottom: 30px;" v-if="resumeInfo.workerInfo.phone.includes('****')"><span @click="downloadResume">下载简历</span>即可获得联系方式</div>
                </div>
                <div class="reinfo-pub">
                    <div class="reinfo-pub-tit">工作经历</div>
                    <div class="exp-listsbox">
                        <ul class="exp-list" v-if="resumeInfo.expList.length > 0">
                            <li class="exp-li" v-for="item in resumeInfo.expList">
                                <div class="exp-time">
                                    {{item.inTime.split(" ")[0]}} ~ {{item.outTime.split(" ")[0]}}
                                </div>
                                <div class="exp-tit">
                                    <h4 class="exp-h6">{{item.companyName}}</h4>
                                    <p>（{{item.positionName}}）</p>
                                </div>
                                <div class="exp-workcon">
                                    <div>工作内容：</div>
                                    <p style="width: 568px;">{{item.workDesc}}</p>
                                </div>
                                <!--<div class="exp-workcon">-->
                                <!--<div>主要业绩：</div>-->
                                <!--<p style="width: 568px;">没有什么混日子，没有什么混日子没有什么混日子</p>-->
                                <!--</div>-->
                            </li>
                        </ul>
                        <div  v-else style="color:#666;margin-left:25px;">
                            暂无工作经历
                        </div>
                    </div>

                </div>
                <div class="reinfo-pub">
                    <div class="reinfo-pub-tit">期望工作</div>
                    <dl class="expect-list" v-for="(item,index) in resumeInfo.ecpList">
                        <!-- <dt>期望{{index}}</dt> -->
                        <dd class="expect-firli">
                            <i class="iconfont icon-career_ico"></i>
                            <span>{{item.positionName}}</span>
                        </dd>
                        <dd>
                            <i class="iconfont icon-loction_ico"></i>
                            <span>{{item.cityName}}</span>
                        </dd>
                        <dd>
                            <i class="iconfont icon-money_ico1"></i>
                            <span class="reinfo-money"
                                  v-if="item.minSalary == item.maxSalary">￥{{item.maxSalary}}</span>
                            <span v-else>￥{{item.minSalary}}-{{item.maxSalary}}</span>
                        </dd>
                    </dl>
                    <div v-show="resumeInfo.ecpList.length == 0" style="color:#666;margin-left:25px;margin-top:20px;">
                        暂无期望工作
                    </div>
                </div>
                <div class="reinfo-pub" v-if="resumeInfo.workerInfo.brief">
                    <div class="reinfo-pub-tit">自我描述</div>
                    <div class="reinfo-selfintr" v-if="resumeInfo.workerInfo.brief">
                        <p v-for="item in resumeInfo.workerInfo.brief.split('\n')">{{item}}</p>
                    </div>
                    <!-- <textarea class="reinfo-selfintr" id="textarea" style="overflow: hidden;resize: none;background:#fff;width:100%;" v-if="resumeInfo.workerInfo.brief" :value="resumeInfo.workerInfo.brief" disabled></textarea> -->

                    <div class="reinfo-selfintr" v-else>暂无自我描述</div>
                </div>
            </div>
        </div>
        <confirmLayer v-show= 'showAddResume' :id='addResumeId' :name='addResumeName' :close="hideAddResume"></confirmLayer>
        <router-view></router-view>
    </div>
</template>
<script>
import { sex } from "../../filters/";
import confirmLayer from "./confirm";

export default {
  data() {
    return {
      resumeid: "",
      resumeInfo: null,
      options: {
        text: "加载中，请稍后",
        target: "#seeinfo"
      },
      showAddResume: false,
      addResumeId: "", //添加简历的id
      addResumeName: "" //添加简历的名字
    };
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.loadingObj = vm.$loading(vm.options);
    });
  },
  components: {
    confirmLayer
  },
  created() {
    let id = this.$route.query.workerId;
    if (id) {
      this.resumeid = id;
      this.getInfo(id);
    }
  },
  beforeRouteUpdate(to, from, next) {
    this.getInfo(this.resumeid);
    next();
  },
  filters: {
    sex: sex
  },
  methods: {
    getInfo(id) {
      let url = `/wapi/hr/seeResume?workerId=${id}`;
      this.axios.get(url).then(res => {
        this.loadingObj.close();
        if (res.success) {
          this.resumeInfo = res.data;
        }
      });
    },
    //隐藏添加人才弹层
    hideAddResume() {
      this.showAddResume = false; //隐藏添加人才弹层
    },
    downloadResume() {
      this.showAddResume = true; //显示添加人才弹层
      this.addResumeId = this.resumeid;
      this.addResumeName = this.resumeInfo.workerInfo.name;
    }
  }
};
</script>
<style scoped lang="less">
@import "../../assets/css/resume";
.resume-download {
  position: absolute;
  top: 15px;
  right: -15px;
  cursor: pointer;
  z-index: 20;
}
.resume-download:hover .addimg {
  filter: grayscale(0.6);
  transition: all 0.3s ease;
  transform: scale(1.05);
}
</style>



// WEBPACK FOOTER //
// seeinfo.vue?1d082e54